import { api } from './axios'

/**
 * O PDF vem de um endpoint @Open() do backend, que rerenderiza o certificado a cada acesso — por
 * isso é um link direto (abre em outra aba), e não uma chamada pelo axios.
 */
export function certificadoPdfUrl(identificacaoCertificado: string) {
  return `${api.defaults.baseURL}/certificados/render/${identificacaoCertificado}`
}

/** Página pública de validação — a mesma que o QR code impresso no certificado aponta. */
export function certificadoValidacaoUrl(identificacaoCertificado: string) {
  const appUrl = import.meta.env.VITE_APP_URL ?? 'https://app.newdriver.com.br'
  return `${appUrl}/certificado/${identificacaoCertificado}`
}
